var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg260UnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "188.632,0 0,0 0,39.954 188.632,163.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,136.598 0,188.632 79.419,188.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,323.369 0,375.402 79.419,323.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "512,39.954 512,0 323.368,0 323.368,163.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "512,375.402 512,323.369 432.581,323.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "323.368,348.46 323.368,512 512,512 512,472.046  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "512,188.632 512,136.598 432.581,188.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,472.046 0,512 188.632,512 188.632,348.46  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "512,472.046 512,432.118 344.465,323.369 393.961,323.369 512,399.989 512,375.402    432.581,323.369 512,323.369 512,296.421 296.421,296.421 296.421,512 323.368,512 323.368,348.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,296.421 0,323.369 79.419,323.369 0,375.402 0,413.203 138.395,323.369 187.891,323.369    0,445.332 0,472.046 188.632,348.46 188.632,512 215.579,512 215.579,296.421  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "215.579,0 188.632,0 188.632,163.54 0,39.954 0,83.679 161.684,188.632 112.188,188.632    0,115.807 0,136.598 79.419,188.632 0,188.632 0,215.579 215.579,215.579  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "512,215.579 512,188.632 432.581,188.632 512,136.598 512,98.314 372.864,188.632    323.368,188.632 512,66.185 512,39.954 323.368,163.54 323.368,0 296.421,0 296.421,215.579  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "512,296.421 512,215.579 296.421,215.579 296.421,0 215.579,0 215.579,215.579 0,215.579    0,296.421 215.579,296.421 215.579,512 296.421,512 296.421,296.421  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "138.395,323.369 0,413.203 0,445.332 187.891,323.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "344.465,323.369 512,432.118 512,399.989 393.961,323.369  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "161.684,188.632 0,83.679 0,115.807 112.188,188.632  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "372.864,188.632 512,98.314 512,66.185 323.368,188.632  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg260UnitedKingdom);
export default __webpack_public_path__ + "static/media/260-united-kingdom.75ed941c0dcc0fc17a9c8296d4db7542.svg";
export { ForwardRef as ReactComponent };